module.exports = __webpack_public_path__ + "static/media/alert.3fbeef10.svg";